import {SalesLeaguePeriod} from '@dms/api/sales';

export const SALES_LEAGUE_PERIODS: readonly SalesLeaguePeriod[] = [
  'week',
  'month',
  'quarter',
  'year',
];

export const DEFAULT_SALES_LEAGUE_PERIOD: SalesLeaguePeriod = 'month';

export const SALES_LEAGUE_PERIOD_LABEL: Record<SalesLeaguePeriod, string> = {
  week: 'page.salesLeague.period.week',
  month: 'page.salesLeague.period.month',
  quarter: 'page.salesLeague.period.quarter',
  year: 'page.salesLeague.period.year',
};

export const SALES_LEAGUE_PERIOD_QUERY_PARAM = 'period';
